import * as platform from 'platform';

export const browserName = (): string => platform.name && platform.name.toLowerCase();

const platformFamily = platform.os.family;
const platformVersion = platform.os.version;

const FAMILY_OSX = 'OS X';
const FAMILY_LINUXI86 = 'Linux i686';
const FAMILY_UBUNTU = 'Ubuntu';
const FAMILY_WINDOWS = 'Windows';
const FAMILY_WINDOWS_NT = 'Windows NT';
const FAMILY_DEBIAN = 'Debian';

const FAMILY_PATTERN_WINDOWS = /windows/i;
const FAMILY_PATTERN_LINUX = /linux/i;

const isWindowsPlatform = () => FAMILY_PATTERN_WINDOWS.test(platformFamily);
const isLinuxPlatform = () => FAMILY_PATTERN_LINUX.test(platformFamily);

export const getOsPlatform = () => {
  switch (platformFamily) {
    case FAMILY_OSX:
      return 'mac';
    case FAMILY_WINDOWS_NT:
    case FAMILY_WINDOWS:
      if (platformVersion === '10') {
        return 'Windows10';
      }
      if (platformVersion === '11') {
        return 'Windows11';
      } else {
        return 'Windows';
      }

    case FAMILY_LINUXI86:
      return 'linux';
    case FAMILY_DEBIAN:
    case FAMILY_UBUNTU:
      return 'debian_ubuntu';
    default:
      if (isWindowsPlatform()) {
        return 'windows';
      } else if (isLinuxPlatform()) {
        return 'linux';
      }
      return 'other';
  }
};
